export default __webpack_public_path__ + "static/media/icon__9.c4c7fbab.svg";